import { useMemo } from 'react';
import { FormsV1 } from '@frontend/api-digital-forms';
import { useTranslation } from '@frontend/i18n';
import { DEFAULT_DFX_HTTP_OPTIONS } from '../../constants';
import { LegalTypes } from '../../types';

type LegalContentInfo = {
  header: string;
  content?: string;
  error: string;
};

export const useGetLegalContent = (locationId: string, documentType: LegalTypes.DocumentType) => {
  const { t } = useTranslation('digital-forms-experience');
  const legalTermsQuery = FormsV1.Queries.useGetLegalTermsQuery({
    request: { companyId: locationId },
    options: { enabled: !!locationId },
    httpOptions: DEFAULT_DFX_HTTP_OPTIONS,
  });

  const isPrivacyPolicy = documentType === 'privacy-policy';

  const legalContentInfo = useMemo<LegalContentInfo>(() => {
    if (isPrivacyPolicy) {
      return {
        header: t('Privacy Policy'),
        error: t('No privacy policy found'),
        content: legalTermsQuery.data?.records?.find((record: any) => record.type === 'Privacy Policy')?.content || '',
      };
    } else {
      return {
        header: t('Terms & Conditions'),
        error: t('No terms & conditions found'),
        content:
          legalTermsQuery.data?.records?.find((record: any) => record.type === 'Terms and Conditions')?.content || '',
      };
    }
  }, [isPrivacyPolicy, legalTermsQuery.data?.records, t]);

  return {
    legalContentInfo,
    isLoading: legalTermsQuery.isLoading,
    isError: legalTermsQuery.isError,
  };
};
